import React, { useState } from 'react';
import { Card, Box, InlineStack, Text, Collapsible, DataTable, BlockStack } from '@shopify/polaris';
import { ChevronUpIcon, ChevronDownIcon } from '@shopify/polaris-icons';
import { METAFIELD_ATTRIBUTES_ITEMS } from '../../utils';

const MetafieldAttributes = () => {
    const [expanded, setExpanded] = useState(0);

    return (
        <Card padding='0'>
            <Box padding='400' paddingBlockEnd='400'>
                <BlockStack>
                    <InlineStack align='space-between' blockAlign='center'>
                        <Text variant="headingMd" as="h5">
                            Show the following metafields in the product page
                        </Text>
                    </InlineStack>
                    <Text as='p' variant='bodyMd'>
                        These metafields are used to store the price and other information for the product.
                    </Text>
                </BlockStack>
            </Box>
            <Box padding='200' paddingBlockEnd='200'>
                {METAFIELD_ATTRIBUTES_ITEMS.map(({ title, id, headings, rows }) => {
                    const isExpanded = expanded === id;
                    return (
                        <Box
                            borderBlockEndWidth='025'
                            borderColor='border'
                            background='bg-surface-secondary'
                            key={id}
                        >
                            <Box paddingBlock='300' paddingInline='400'>
                                <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        return setExpanded((prev) => (id === prev ? null : id));
                                    }}
                                >
                                    <InlineStack align='space-between' blockAlign='center'>
                                        <Text variant="headingMd" as="h6">
                                            {title}
                                        </Text>
                                        {isExpanded ? (
                                            <ChevronUpIcon width='1.5rem' height='1.5rem' />
                                        ) : (
                                            <ChevronDownIcon width='1.5rem' height='1.5rem' />
                                        )}
                                    </InlineStack>
                                </div>
                            </Box>
                            <Collapsible open={isExpanded}>
                                <Box padding='400' background='bg-surface'>
                                    <DataTable
                                        columnContentTypes={['text', 'text', 'text']}
                                        headings={headings}
                                        rows={rows}
                                    />
                                </Box>
                            </Collapsible>
                        </Box>
                    );
                })}
            </Box>
        </Card>
    );
};

export default MetafieldAttributes;
